import * as z from "zod";

export const PayoutStatusSchema = z.enum(["pending", "paid", "failed"]);

export type PayoutStatus = z.infer<typeof PayoutStatusSchema>;

export const PartnerPayoutSchema = z.object({
  id: z.string(),
  periodStart: z.iso.date(),
  periodEnd: z.iso.date(),
  paidOn: z.iso.date().nullable(),
  /** Cents, stringified to preserve BigInt precision over the wire. */
  amountCents: z.string(),
  status: PayoutStatusSchema,
  payoutMethod: z.string(),
});

export type PartnerPayout = z.infer<typeof PartnerPayoutSchema>;
